export enum PACKAGE_STATES {
  PENDIENTE = 0,
  GESTION_PAGO = 1,
  PAGADO = 2,
  PREPARACION = 3,
  PREPARADO = 4,
  EN_VIAJE = 5,
  RECIBIDO = 6,
  FINALIZADO = 7,
  CANCELADO = 8,
  //FIXME temporal hasta OR
  REPARACION = 9,
}

export const PackageStateString = {
  [PACKAGE_STATES.PENDIENTE]: 'Pendiente',
  [PACKAGE_STATES.GESTION_PAGO]: 'Gestión de pago',
  [PACKAGE_STATES.PAGADO]: 'Pagado',
  [PACKAGE_STATES.PREPARACION]: 'En preparación',
  [PACKAGE_STATES.PREPARADO]: 'Preparado',
  [PACKAGE_STATES.EN_VIAJE]: 'En viaje',
  [PACKAGE_STATES.RECIBIDO]: 'Recibido',
  [PACKAGE_STATES.FINALIZADO]: 'Finalizado',
  [PACKAGE_STATES.CANCELADO]: 'Cancelado',
  [PACKAGE_STATES.REPARACION]: 'En reparación',
};

export const PackageStateForReceptionsString = {
  [PACKAGE_STATES.PENDIENTE]: 'Pendiente',
  [PACKAGE_STATES.EN_VIAJE]: 'En viaje',
  [PACKAGE_STATES.RECIBIDO]: 'Recibido',
  [PACKAGE_STATES.FINALIZADO]: 'Finalizado',
  [PACKAGE_STATES.CANCELADO]: 'Cancelado',
};
